import { render, staticRenderFns } from "./studentDetails.vue?vue&type=template&id=6e172df4&scoped=true"
import script from "./studentDetails.vue?vue&type=script&lang=js"
export * from "./studentDetails.vue?vue&type=script&lang=js"
import style0 from "./studentDetails.vue?vue&type=style&index=0&id=6e172df4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e172df4",
  null
  
)

export default component.exports